let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cHkI1")).then(() => parcelRequire('FIpv8'));